import { doPost } from '../src/utils'
import { registration_pt_br_path, dashboard_pt_br_path } from '../routes'

let user_token = null

export const initializeFBSDK = () => {
  window.fbLoginHandler = async () => {

    await FB.getLoginStatus(checkStatus)
    const data = await getFbUserData()

    if (data) {
      logIn(data)
    } else {
      alert('Erro ao conectar com a conta do Facebook.')
    }
  }

  window.fbAsyncInit = function() {
    FB.init({
      appId      : gon.facebook_app_id,
      cookie     : true,
      xfbml      : true,
      version    : 'v11.0'
    });

    FB.getLoginStatus(checkStatus);
  }

  function logIn (userData, token) {
    doPost(registration_pt_br_path(), JSON.stringify({ ...userData, token: user_token, provider: 'facebook' }), (res) => {
      console.log('resposta do backend', res)

      window.location.href = dashboard_pt_br_path()
    })
  }

  function getFbUserData() {
    return new Promise((resolve, reject) => {
      FB.api('/me', {locale: 'en_US', fields: 'id,first_name,last_name,email,link,gender,locale,picture'},
        (res) => { resolve(res) })
    })
  }

  async function checkStatus(response) {
    // getLoginStatus()
    switch (response.status) {
      case 'connected':
        user_token = response?.authResponse?.accessToken
        const userData = await getFbUserData();
        // logIn(userData)
        return
      case 'unknown':
        return
    }
  }
  (function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/pt_BR/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));
}